import { motion } from "framer-motion";
import { ArchCartouche } from "@/components/Mughal";

// Every line sourced from amritasen.com press/music pages and highgateent.com — no invented honours.
const CREDITS = [
  '"Jai Ho" — performed with A.R. Rahman at the 2009 Academy Awards, from Slumdog Millionaire',
  "The Oprah Winfrey Show",
  "The Tonight Show with Jay Leno",
  "Recordings and collaborations with A.R. Rahman, Timbaland, Weezer, Justin Timberlake's The 20/20 Experience, Ozomatli, Jeremy Soule and Brody Brown",
  "Leonardo DiCaprio's Ice on Fire — with composer Jeremy Soule",
  "Co-founder, Highgate Entertainment — producer of The Night Manager (Disney+ Hotstar, 2023), Search: The Naina Murder Case (JioHotstar, 2025) and Wheel of Fortune India (Sony Entertainment Television, 2025); The Cleaning Lady, The Cult and Eternal Glory on the slate",
  "MAC x BollyDoll collection, 2014",
  "BollyDoll — first launched through Art Basel, 2011",
];

const CreditsSection = () => (
  <section data-testid="credits-section" className="relative mx-auto w-full max-w-2xl px-6 py-8 md:py-12">
    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.2 }}
      className="mb-12"
    >
      <ArchCartouche className="text-[#d4af37]/70">
        <span className="text-xs uppercase" style={{ letterSpacing: "0.5em" }}>
          Credits
        </span>
      </ArchCartouche>
    </motion.p>
    <ul className="flex flex-col gap-7">
      {CREDITS.map((c, i) => (
        <motion.li
          key={c}
          data-testid={`credit-item-${i}`}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.9, delay: i * 0.06, ease: "easeOut" }}
          className="font-serif-display text-lg font-light leading-relaxed text-[#f3ead6]/80 md:text-xl"
        >
          {c}
        </motion.li>
      ))}
    </ul>
  </section>
);

export default CreditsSection;
